import { processRequest } from '../../../services/Api';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { renewalSubscriptionModalActionTypes } from './Constants';
import * as renewalSubscriptionModalActions from './Actions';
import * as errorHandlerActions from '../../errorHandler/Actions';

export default function* () {
	yield all([
		takeLatest(
			renewalSubscriptionModalActionTypes.GET_RENEWAL_SUBSCRIPTION,
			handleGetRenewalSubscriptionRequest,
		),
	]);
}

export function* handleGetRenewalSubscriptionRequest({ payload }) {
	const { last_chance_key } = payload || {};
	try {
		const { data } = yield call(processRequest, `public/packages/last_chance`, 'GET', {
			last_chance_key,
		});
		yield put(renewalSubscriptionModalActions.getRenewalSubscriptionSuccess(data));
	} catch (e) {
		yield put(errorHandlerActions.handleError(e, 'notification'));
		yield put(renewalSubscriptionModalActions.getRenewalSubscriptionError());
	}
}
